// DoughnutChart.js
import React from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import Chart from "react-apexcharts"
import PropTypes from "prop-types"
import formatCurrency from "constants/formatCurrency"

const DoughnutChart = ({ title, total, labels, series }) => {
  if (!series || series.length === 0 || series.every(v => v === 0)) {
    return null
  }

  const colors = [
    "#FFCA5C",
    "#55A1D0",
    "#FF5858",
    "#D2FAC8",
    "#FFEBc3",
    "#6e4c0aff"
  ]

  const options = {
    chart: { type: "donut" },
    labels: labels,
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            show: true,
            // 1. THIS controls the styling of the styling of the Number/Value
            value: {
              show: true,
              fontSize: "20px",
              fontWeight: 600,
              color: "#ffffff", // <--- Set this to white
              offsetY: 16 // Adjusts vertical position slightly if needed
            },
            // 2. THIS controls the "Total" label and calculation logic
            total: {
              show: true,
              label: "Total",
              color: "#ffffff", // <--- Set "Total" text to white
              fontSize: "16px", // Usually the label is slightly smaller than the value
              fontWeight: 400,
              formatter: function (w) {
                const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                return `$${formatCurrency(total)}`
              }
            }
          }
        }
      }
    },
    colors
  }

  return (
    <Card className="accordion-gradient-border text-white" style={{ background: "#3C3C3C" }}>
      <CardBody>
        <h5 className="mb-3">{title}</h5>
        <Row>
          {/* Chart Column */}
          <Col xs="12" md="6" className="d-flex justify-content-center">
            <Chart options={options} series={series} type="donut" height={250} />
          </Col>

          {/* Legend Column */}
          <Col xs="12" md="6" className="d-flex flex-column justify-content-center">
            {labels.map((label, idx) => (
              <div key={idx} className="d-flex align-items-center mb-2">
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "12px",
                    backgroundColor: colors[idx % colors.length],
                    borderRadius: "50%",
                    marginRight: "8px"
                  }}
                ></span>
                <span>
                  {label} – ${formatCurrency(series[idx] || 0)}
                </span>
              </div>
            ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

DoughnutChart.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  labels: PropTypes.array,
  series: PropTypes.array
}

export default DoughnutChart